




































































































































































// @ is an alias to /src
import apiFlux from '@/api/flux'
import axios from 'axios'
import { Component, Vue, Watch } from 'vue-property-decorator'
import CheckState from '@/components/shared/CheckState.vue'
import { toSubArray } from '@/utils/groupBy'
import { AloItemflux } from '@/models/alo/AloItemflux'
import { directPayloadQuery } from '@/utils/api'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import { AloBase } from '@/models/alo/AloBase'
import ReadConfig from '@/components/flux/read/ReadConfig.vue'
import ReadCodic from '@/components/flux/read/ReadCodic.vue'
import ReadPartenaires from '@/components/flux/read/ReadPartenaires.vue'
import ReadCriteres from '@/components/flux/read/ReadCriteres.vue'
import ReadDartyPro from '@/components/flux/read/ReadDartyPro.vue'
import ReadItemFlux from '@/components/flux/read/ReadItemFlux.vue'
import ReadDiscountRatio from '@/components/flux/read/ReadDiscountRatio.vue'
import ReadMercurial from '@/components/flux/read/ReadMercurial.vue'
import ReadMarques from '@/components/flux/read/ReadMarques.vue'
import ReadMetas from '@/components/flux/read/ReadMetas.vue'
import ReadParamCw from '@/components/flux/read/ReadParamCw.vue'
import ReadSpecifique from '@/components/flux/read/ReadSpecifique.vue'
import ReadFollowers from '@/components/flux/read/ReadFollowers.vue'
import ReadProfilExclusion from '@/components/flux/read/ReadProfilExclusion.vue'
import FileDownload from 'js-file-download'
import { ItemfluxObjectType } from '@/enum/ItemfluxObjectType'
import { FluxRestrictFlag } from '@/enum/FluxRestrictFlag'
import { ExportCatalogType } from '@/enum/ExportCatalogType'
import { AloDiscountRatio } from '@/models/alo/AloDiscountRatio'
import { AloMercurial } from '@/models/alo/AloMercurial'

@Component({
  name: 'ModifyFlux', 
  props: {
    fluxId:Number
  },
  components: { CheckState,ReadConfig,ReadPartenaires,ReadCriteres,ReadDartyPro,ReadItemFlux,ReadDiscountRatio,ReadMercurial,ReadMarques,ReadMetas,ReadCodic,ReadParamCw,ReadSpecifique,ReadFollowers,ReadProfilExclusion },
})

export default class ModifyPartenaires extends Vue {
  private fluxId!: number
  private showError = false
  private rightDrawer = false

  private loadingFlux = false
  private loadingItemsFlux = false
  private itemsFlux: Array<AloItemflux> = []  
  
  private loadingDiscountRatios = false
  private discountItems: Array<AloDiscountRatio> = []    

  private loadingMercurials = false
  private mercurials: Array<AloMercurial> = []    

  private showBuild = false
  private generatingSuccess = false
  private generatingResult = ""
  private generating = false

  private showExport = false
  private exporting = false
  private exportingName = ""
  
  get restrictedFlag(){ return this.flux.flxRestrictedFlag.split(', ')}  
  get isCentralWeb() {return this.$store.myGetters.isCentralWeb}
  get isDartyPro() {return this.$store.myGetters.isDartyPro}
  get noRestrict() {return this.isCentralWeb && this.noRestrictIfCentralWeb}

  get noSave() { return !this.noRestrict &&  this.restrictedFlag.some(it => it == FluxRestrictFlag.noSave)}
  get noRemove() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noRemove)}
  get noChangeItemIncluded() { return !this.noRestrict && (this.noDisplayItemIncluded || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeItemIncluded))}
  get noChangeItemExcluded() { return !this.noRestrict && (this.noDisplayItemExcluded || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeItemExcluded))}
  get noChangeMarque() { return !this.noRestrict && (this.noDisplayMarque || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeMarque))}  
  get noChangeProfilExclusion() { return !this.noRestrict && (this.noDisplayProfilExclusion || this.noSave)}  
  get noChangeMetaProduit() { return !this.noRestrict && (this.noDisplayMetaProduit || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeMetaProduit))}
  get noChangeMetaFamille() { return !this.noRestrict && (this.noDisplayMetaFamille || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeMetaFamille))}
  get noChangeDispo() { return !this.noRestrict && (this.noDisplayDispo || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeDispo))}
  get noChangeMkp() { return !this.noRestrict && (this.noDisplayMkp || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeMkp))}
  get noChangePtn() { return !this.noRestrict && (this.noDisplayPtn || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangePtn))}
  get noChangeSeg() { return !this.noRestrict && (this.noDisplaySeg || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeSeg))}
  get noChangeStock() { return !this.noRestrict && (this.noDisplayStock || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeStock))}
  get noChangeEntrepot() { return !this.noRestrict && (this.noDisplayEntrepot || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeEntrepot))}
  get noChangeRTB() { return !this.noRestrict && (this.noDisplayRTB || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeRTB))}
  get noChangeStatut() { return !this.noRestrict && (this.noDisplayStatut || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeStatut))}
  get noChangeCodicExcluded() { return !this.noRestrict && (this.noDisplayCodicExcluded || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeCodicExcluded))}  
  get noDisplayItemIncluded() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayItemIncluded)}
  get noDisplayItemExcluded() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayItemExcluded)}
  get noDisplayMarque() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayMarque)}
  get noDisplayProfilExclusion() { return !this.noRestrict && !this.isDartyPro}  
  get noDisplayMetaProduit() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayMetaProduit)}
  get noDisplayMetaFamille() { return true }//!this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayMetaFamille)}
  get noDisplayDispo() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayDispo)}
  get noDisplayMkp() { return this.isDartyPro || (!this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayMkp))}
  get noDisplayPtn() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayPtn)}
  get noDisplaySeg() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplaySeg)}
  get noDisplayStock() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayStock)}
  get noDisplayEntrepot() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayEntrepot)}
  get noDisplayRTB() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayRTB)}
  get noDisplayStatut() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayStatut)}
  get noDirectBuild() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDirectBuild)}
  get noDisplayCodicExcluded() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayCodicExcluded)}
  get noEvaluation() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noEvaluation)}
  get noDisplayExcludePb() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayExcludePb)}
  get noChangeExcludePb() { return !this.noRestrict && (this.noDisplayExcludePb || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeExcludePb))}
  get noDirectCsvBuild() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDirectCsvBuild)}  
  get noChangeTransporter() { return !this.noRestrict && (this.noDisplayTransporter || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeTransporter))}
  get noDisplayTransporter() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayTransporter)}
  get noChangeDiscount() { return !this.noRestrict && (this.noDisplayDiscount || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeDiscount))}
  
  get noDisplayDiscount() { return !this.isDartyPro || (!this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayDiscount))}
  
  get noChangeTarifPro() { return !this.noRestrict && (this.noDisplayTarifPro || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeTarifPro))}
  get noDisplayTarifPro() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayTarifPro)}
  get noRestrictIfCentralWeb() { return this.restrictedFlag.some(it => it == FluxRestrictFlag.noRestrictIfCentralWeb)}
  get noDisplayFollowers() { return !this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayFollowers)}
  get noChangeFollowers() { return !this.noRestrict && (this.noDisplayFollowers || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeFollowers))}    
  get noDisplayMercurial() { return !this.isDartyPro || (!this.noRestrict && this.restrictedFlag.some(it => it == FluxRestrictFlag.noDisplayMercurial))}
  get noChangeMercurial() { return !this.noRestrict && (this.noDisplayMercurial || this.noSave || this.restrictedFlag.some(it => it == FluxRestrictFlag.noChangeMercurial))}    
  
  //computed d'aide d'affichage des sections
  get noDisplayDecisionnels()  { return this.noDisplaySeg && this.noDisplaySeg && this.noDisplayStock && this.noDisplayEntrepot && this.noDisplayTransporter}
  get noDisplayDecisionnelsDartyPro()  { return !this.isDartyPro || (this.noDisplayRTB && this.noDisplayStatut && this.noDisplayExcludePb && this.noDisplayTarifPro)}

  get ExportCatalogType(){
    return ExportCatalogType
  }
  
  get flux() { 
    return {...getDefaultAloFlux(),...this.$store.myGetters.flux[this.fluxId]}
  }  

  loadFlux(){        
    this.loadingFlux = true
    this.$store.myActions.ADM_FLUX_DETAIL_REQUEST(this.fluxId)
    .catch(()=>{
      this.$router.push({name:"Flux"})
    })
    .finally(() => {
      this.loadingFlux = false
    })
  }

  loadFluxItems(){
    this.loadingItemsFlux = true
    directPayloadQuery(apiFlux.getItemFlux,this.fluxId,this.$store)    
    .then( (items) => {
      this.itemsFlux = items
    }).finally(() => {
      this.loadingItemsFlux = false
    })
  }

  loadDiscountRatios(){
    this.loadingDiscountRatios = true
    directPayloadQuery(apiFlux.getDiscountRatio,this.fluxId,this.$store)    
    .then( (items) => {
      this.discountItems = items
    }).finally(() => {
      this.loadingDiscountRatios = false
    })
  }

  loadMercurials(){
    this.loadingMercurials = true
    directPayloadQuery(apiFlux.getMercurial,this.fluxId,this.$store)    
    .then( (items) => {
      this.mercurials = items
    }).finally(() => {
      this.loadingMercurials = false
    })
  }

  load(){
    this.$store.myActions.ADM_PARTENAIRE_ENSURE().then(()=>{
      this.loadFlux()
    })    
    this.$store.myActions.CATALOGUE_TREE_ENSURE().then(() => {
      this.loadFluxItems()
      this.loadDiscountRatios()
      if(this.isDartyPro) this.loadMercurials()
    })
  }

  @Watch('fluxId')
  onFluxIdChanged(){
   this.load()
  }

  created(){        
    this.load()      
  }
    

  get arianeItems() {
    const arianeItems =  [
        {
          text: 'Flux',
          disabled: false,          
          to: {name:'Flux'},
          exact:true
        }
      ]
    if(this.flux) {
        arianeItems.push({
          text: this.flux.libelle,
          disabled: true,          
          to: {name:''},
          exact:true
        })
    }
    return arianeItems;
  } 
  
  saveData() {
    this.rightDrawer = false;
  }

  remove(){
    this.$confirm(`Etes vous sûr de vouloir supprimer le flux '${this.flux.libelle}'`).then((answer)=>{
      if(answer){
        this.$store.myActions.ADM_FLUX_DELETE_REQUEST(this.flux.id).then(()=>{
          this.$router.push({name:'Flux'})
        })
      }
    })
  }

  evaluate()  {
    //todo faire l'evaluation
    alert("Fonction non implémentée pour le moment")    
  }

  exportCsv() {
    this.showExport = true
  }

  buildFlux(){
    this.showBuild = true
    this.generatingResult  = ""
    this.generatingSuccess = false
  }

  generateCsvFlux() {
    this.exportingName = `${this.flux.libelle} ${this.flux.id}`
    this.exporting = true
    //@ts-ig
    axios({
      url: this.flux.linkToCsvFeed,
      method: 'GET',      
      responseType: 'blob', // Important //"application/octet-stream"
    }).then((response) => {            
        const name = (response.headers['content-disposition'] as string).split(';') .find(p => p.indexOf(" filename=") == 0)?.replace(" filename=","") || `flux_${this.flux.id}.csv`
        FileDownload(response.data, name);
    }).finally(()=>{
      this.exporting = false
      this.showExport = false
    });
  }

  generateFlux() {
    this.exportingName = `${this.flux.libelle} ${this.flux.id}`
    this.generating = true
    //@ts-ig
    axios({
      url: this.flux.flxDirectBuildUrl,
      method: 'GET'
    }).then((response) => {          
      this.generatingResult = response.data?.data
      this.generatingSuccess = true      
    }).finally(()=>{
      this.generating = false      
    });
  }

}
